import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from "react-router";
import { Text } from "@gravity-ui/uikit";
import { PageBlock } from "@/components/ui/PageBlock";
import { PlaceCardShort } from "@/components/ui/PlaceCard";
import { RoutesList } from "@/router/routesList";
export var Places = function (props) {
    var navigate = useNavigate();
    var onDetailsClickHandler = function (placeId) {
        navigate(RoutesList.Place.getPlaceDetails(placeId));
    };
    return (_jsx(PageBlock, { header: "\u0418\u0437\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0438", isCard: !props.places.length, children: props.places.length === 0 ? (_jsx(Text, { children: "\u041D\u0435\u0442 \u043F\u043B\u043E\u0449\u0430\u0434\u043E\u043A" })) : (props.places.map(function (place) { return (_jsx(PlaceCardShort, { place: place, onDetailsClick: onDetailsClickHandler }, place.id)); })) }));
};
